import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddtaskComponent } from './addtask/addtask.component';
import { DetailtaskComponent } from './detailtask/detailtask.component';
import { EdittaskComponent } from './edittask/edittask.component';
import { TaklistComponent } from './taklist/taklist.component';

const routes: Routes = [
  {
    path: "TaskList",
    component: TaklistComponent,
  },
  {
    path: "AddTask",
    component: AddtaskComponent,
  },
  {
    path: "EditTask/:id",
    component: EdittaskComponent,
  },
  {
    path: "DetailTask/:id",
    component: DetailtaskComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TaskRoutingModule { }
